module.exports = __webpack_public_path__ + "static/quiktrip-11249054a8ead4791881a953d423940d.png";